var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPendingDevice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 369.1 464.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#002154;}.cls-2{fill:#ee7404;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M363.94,334.44v2h-46c-.12-1.62-.26-3.2-.41-4.75-5.12-52.72-28-65-95.93-62.13H142.44C56.22,266,42.53,286.69,45.71,383.68v67.95H0V334.44c0-63,42.18-105.29,105.11-105.29H258.84c48.54,0,84.71,25.08,98.72,65.4A120.18,120.18,0,0,1,363.94,334.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    className: "cls-1",
    d: "M278,65.16A103.12,103.12,0,1,0,223.22,200,104.39,104.39,0,0,0,278,65.16Zm-95.34,96.65a58,58,0,1,1,58-58A58,58,0,0,1,182.65,161.81Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M304.8,462.65c-16-.5-32.09-.75-48.12-1.56-24.11-1.21-41.11-13.13-50.83-35.2-1.13-2.57-2.29-3.53-5.11-3.46-7.88.2-15.77,0-23.65.11-3.52.06-5-1.24-5-4.86q.19-13.06,0-26.15c-.06-3.62,1.46-4.9,5-4.84,8,.13,16.05-.05,24.07.09,2.44,0,3.54-.74,4.54-3,9.79-22.66,27.13-34.71,51.79-35.63,31.94-1.2,63.89-2,95.84-3,10.49-.33,15.72,4.6,15.73,15.12q0,44.42,0,88.83c0,10.52-5.24,15.46-15.72,15.12q-24.27-.81-48.54-1.55Zm-93.7-40a12.53,12.53,0,0,0,.35,1.62,24.09,24.09,0,0,0,1,2.29c9,17.58,23.38,27.69,43.09,28.58,32.9,1.48,65.84,2.16,98.76,3.16,6.25.19,8.93-2.34,8.94-8.63q.06-45,0-90.1c0-6.31-2.67-8.86-8.91-8.67-32.92,1-65.85,1.69-98.75,3.17-19.9.89-34.32,11.11-43.26,28.93a32.77,32.77,0,0,0-1.28,3.55h10.35l-.59-1,4.83-3.62c.76,1.86,2.14,3.71,2.17,5.59.21,11.35.11,22.7.1,34a9.92,9.92,0,0,1-.34,3.68,3.46,3.46,0,0,1-2.31,1.91,3.69,3.69,0,0,1-2.69-1.38c-.62-.79-.67-2-1-3.16Zm-32.8-6.31h43.29V392.8H178.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M354.13,404.72q0,19.29,0,38.59c0,5.32-.5,5.79-5.61,5.64l-74.66-2.15c-5.78-.17-6.17-.55-6.17-6.19q0-36.11,0-72.2c0-5.37.46-5.81,6-6q37.53-1.11,75.07-2.17c4.86-.14,5.4.37,5.41,5.44Q354.16,385.21,354.13,404.72Zm-80.3,36.18,74.1,2.21v-77l-74.1,2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M236.59,404.66A10.37,10.37,0,1,1,246.91,415,10.37,10.37,0,0,1,236.59,404.66Zm5.21-1v1.89c1.72,1.18,3.33,3,5.2,3.37,2.65.44,4.42-1.55,4.42-4.29s-1.77-4.74-4.41-4.31C245.13,400.62,243.52,402.48,241.8,403.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M246.91,387.58c-2.22,0-4.44.13-6.64,0-3.44-.24-4.49-2-2.89-5q3.13-5.85,6.64-11.5c1.94-3.11,4-3.08,5.95.1,2.32,3.76,4.54,7.6,6.62,11.5,1.5,2.81.52,4.57-2.63,4.84-2.33.2-4.7,0-7.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M247.23,421.66c2.21,0,4.44-.15,6.64,0,3.18.26,4.24,2,2.77,4.78-2.13,4-4.4,8-6.83,11.86-1.81,2.86-3.93,2.82-5.76-.1-2.41-3.87-4.66-7.85-6.83-11.86-1.42-2.65-.31-4.36,2.54-4.64,2.47-.24,5-.05,7.47-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M190.39,396.78a7.83,7.83,0,1,1-8.18,7.58A7.78,7.78,0,0,1,190.39,396.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M326.45,376.85c-1.38,0-2.91.38-4.1-.1s-2.28-1.85-3.4-2.82c1-.95,1.88-2.55,3-2.73a34.41,34.41,0,0,1,9.06-.35c1.21.13,2.26,1.82,3.38,2.8-1.13,1-2.13,2.3-3.43,2.77s-3,.11-4.51.11Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingDevice);
export default __webpack_public_path__ + "static/media/pendingDevice.714dac95d40fb29fa2797402161092bc.svg";
export { ForwardRef as ReactComponent };